import type { ReactNode } from "react";
import { Button } from "@themes/pollinator/ui/Button";

export type Props = {
  /** The cohort meeting message slot (typically <SchedulingCohortMessageContainer />). */
  message: ReactNode;
  /** When true, shows the primary "Join Upcoming Meeting" button. */
  hasMeeting: boolean;
  onScheduleClick: () => void;
  onCohortClick: () => void;
  onJoinClick: () => void;
};

export function CohortDashboardBanner({
  message,
  hasMeeting,
  onScheduleClick,
  onCohortClick,
  onJoinClick,
}: Props) {
  return (
    <div className="flex flex-col gap-4 pb-8 border-b border-brand-800 w-full">
      {message}
      <div className="flex flex-col gap-2 md:flex-row md:gap-3">
        <Button
          variant="secondary"
          onClick={onScheduleClick}
          className="w-full md:w-fit"
          data-testid="cohort-banner-schedule"
        >
          Schedule
        </Button>
        <Button
          variant="secondary"
          onClick={onCohortClick}
          className="w-full md:w-fit"
          data-testid="cohort-banner-cohort"
        >
          Cohort
        </Button>
        {hasMeeting && (
          <Button
            variant="primary"
            onClick={onJoinClick}
            className="w-full md:w-fit"
            data-testid="cohort-banner-join"
          >
            Join Upcoming Meeting
          </Button>
        )}
      </div>
    </div>
  );
}

export default CohortDashboardBanner;
